export default {
  metadata: {
    version: '1.0.0',
    id: 'file-uploader-control-1.0.0',
    name: 'JDSFileUploaderControl'
  },
  hierarchy: {
    container: [
      {
        'label-container': [
          'label-jds-text',
          {
            'info-jds-icon-container': ['info-jds-icon']
          }
        ]
      },
      'upload-jds_button',
      'helper-jds-text'
    ]
  },
  base: {
    container: {
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      gap: '{f_3}',
      width: '{f_4}',
      opacity: '{f_5}'
    },
    'label-container': {
      'flex-direction': '{f_6}',
      'justify-content': '{f_7}',
      'align-items': '{f_8}',
      gap: '{f_9}'
    },
    'upload-jds_button': {
      iconLeft: 'ic_upload',
      kind: 'secondary',
      size: 'medium',
      fullWidth: true
    },
    'label-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      textType: 'label'
    },
    'info-jds-icon': {
      size: '{icon_22}',
      color: '{icon_15}',
      value: 'ic_info',
      ic: 'ic_info'
    },
    'info-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_21}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      ic: 'ic_info'
    },
    'helper-jds-text': {
      'font-family': '{text_147}',
      color: '{text_21}',
      'font-size': '{text_146}',
      'line-height': '{text_148}',
      'letter-spacing': '{text_149}',
      'font-weight': '{text_150}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      'upload-jds_button': {
        label: {
          type: 'string',
          name: 'uploadButtonLabel'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText'
        }
      }
    },
    events: {
      'upload-jds_button': {
        onClick: 'onClick'
      },
      'info-jds-icon': {
        onClick: 'onInfoClick'
      }
    },
    a11y: {
      'upload-jds_button': {
        properties: {
          ariaLabel: 'uploadButtonAriaLabel'
        }
      }
    }
  }
};
